import React, { Component } from 'react';
import StyleSheet from 'stilr';
import DocumentMeta from 'react-document-meta';

import CategoryCards from '../common/category-cards';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  center: {
    maxWidth: '90%',
    textAlign: 'center'
  }
});

class NotFound extends Component {
  render() {
    if (this.props.staticContext) {
      this.props.staticContext.status = this.props.route.statusCode || 404;
    }
    return (
      <DocumentMeta title="Siden blev ikke fundet - SparPenge.dk" extend>
        <div className={styles.container}>
          <div className={styles.center}>
            <h3>Siden du leder efter kunne ikke findes</h3>
            <h5>Vi er gjort opmærksom på problemet</h5>
          </div>
        </div>

        <hr />
        {this.props.feed ? null : (<div>
          <div className={styles.container}>
          <div className={styles.center}>
            <h5>Ledte du efter nogle af følgende sider?</h5>
          </div>
          </div>

          <br />
          
          <CategoryCards />
        </div>)}

        <br />
        <br />
      </DocumentMeta>
    );
  }
}

export default NotFound;
